import { Badge, Card, Group } from "@mantine/core";
import type { ReactNode } from "react";
import { memo, type FC } from "react";
import { FormattedMessage } from "react-intl";
import { TilesetItemControls } from "./TilesetItemControls";
import { StatusIcon } from "./StatusIcon";
import type { Tileset, TilesetDataset, TilesetVersion } from "../types/tileset";
import { TilesetItemTitle } from "./TilesetItemTitle";
import type { AccountInfo } from "../../../../types/account";

interface TilesetItemProps {
  tileset: Tileset;
  account: AccountInfo;
  version: TilesetVersion | null;
  dataset: TilesetDataset | null;
  controls?: ReactNode;
  title?: ReactNode;
}

export const TilesetItemCondensed: FC<TilesetItemProps> = memo(({ account, tileset, version, dataset, controls, title }) => {
  const {
    scope,
  } = tileset;

  return (
    <Card withBorder shadow="sm" radius="md" p="sm">
      <Group justify="space-between" align="center">
        <Group>
          {version && (
            <StatusIcon version={version} />
          )}
          {title && title}
          {!title && (
            <TilesetItemTitle
              tileset={tileset}
              dataset={dataset}
              version={version}
            />
          )}

          <Badge size="sm" color={scope === "private" ? "blue" : "green"}>
            {scope === "private"
              ? <FormattedMessage defaultMessage="Private" id="label.private" />
              : <FormattedMessage defaultMessage="Public" id="label.public" />}
          </Badge>
        </Group>

        {controls && controls}
        {!controls && (
          <TilesetItemControls
            account={account}
            tileset={tileset}
            version={version}
            dataset={dataset}
          />
        )}
      </Group>
    </Card>
  );
});

TilesetItemCondensed.displayName = "TilesetItemCondensed";
